// src/pages/creditNote/CreditNoteA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { formatCurrency } from '../../utils/orderCalculations';
import { getImageUrl } from '../../utils/imageUtils';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';

const CreditNoteA4Document = ({ creditNote }) => {
  const { t } = useLocalization();

  if (!creditNote) return null;

  const remaining = Math.max(0, Number(creditNote.amount || 0) - Number(creditNote.appliedAmount || 0));

  return (
    <A4DocumentLayout
      title={t('creditNote.creditNoteNumber')}
      logoUrl={getImageUrl(creditNote.originalOrder?.Shop?.logo)}
      subtitle={t('creditNote.officialCreditNote', 'Official Credit Note')}
      documentNumber={`#${creditNote.creditNoteNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(creditNote.createdAt).toLocaleString() },
        { label: t('common.status'), value: (creditNote.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('creditNote.customer'),
          primary: creditNote.customer?.name || t('common.na'),
          lines: [`${t('creditNote.originalOrder')}: #${creditNote.originalOrder?.orderNumber || t('common.na')}`],
        },
        {
          title: t('creditNote.sourceType'),
          lines: [t(`creditNote.sourceType_${creditNote.sourceType}`)],
        },
      ]}
      summary={{
        notes: { label: t('creditNote.reason'), text: creditNote.reason || t('common.none', 'None') },
        totals: [
          { label: t('creditNote.amount'), value: formatCurrency(creditNote.amount) },
          { label: t('creditNote.appliedAmount'), value: formatCurrency(creditNote.appliedAmount) },
          { label: t('creditNote.remainingAmount'), value: formatCurrency(remaining), variant: 'grand' },
        ],
      }}
      footerNote="This is a computer-generated credit note."
    />
  );
};

export default CreditNoteA4Document;
